import { ApiMethods } from "../models/ApiMethods";
import { ApiEndpoints } from "../models/ApiEndpoints";
import { ApiMutateHook, useApiMutate } from "@skanska/vsa-client-auth";

export function useApiCache(): ApiMutateHook<void, void> {
  return useApiMutate<void, void>(ApiEndpoints.Cache, ApiMethods.Delete);
}

export function useApiNavigationCache(): ApiMutateHook<void, void> {
  return useApiMutate<void, void>(
    ApiEndpoints.CacheNavigation,
    ApiMethods.Post
  );
}
